import TEAlert from './TEAlert';

export default TEAlert;
